
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Button',
  props: {
    icon: { type: String, default: '' },
  },
});
